import envVars from '../../../constants/envVars';
const showRTMDischargeFeature = envVars.SHOW_RTM_DISCHARGE_FEATURE;
export default showRTMDischargeFeature;
